<template lang="pug">
    v-row(justify='center')
      v-dialog(v-model='Datos.dialog' persistent='' max-width='2000px')
        template(v-slot:activator='{ on }')
          v-card-actions
            v-spacer
            v-btn(small :disabled ='Datos.lista_de_compras_existencias.length == 0'  color='primary' v-on='on') Solicitar
        v-card
          v-container.py-5
              h1.mb-3 Detallar requerimientos de compra 
              p Se han seleccionado los siguientes productos:
          
              v-data-table.elevation-4.my-5( :headers='itemHeadersRequered' :items='Datos.lista_de_compras_existencias' item-key='key' )
                template(v-slot:item.cantidad='{item}')
                  v-text-field(v-model.number='item.cantidad' label='Cantidad' type='number')
          v-card-actions
              v-spacer
              v-btn(color='primary' text='' @click='Datos.dialog = false') Cerrar
              v-btn(color='primary' text='' @click='save()') Guardar
</template>
<script>
import {mapActions, mapGetters, mapState, mapMutations} from 'vuex'
export default {
	data:()=>({
		itemHeadersRequered:[
      { text: 'Código',                 value: 'codigo', sortable: false    },
      { text: 'Nombre del Producto',    value: 'descripcion'},
      { text: 'Presentación',    value: 'presentacion'},

      { text: 'Cantidad',      value: 'cantidad' }
    ],
	}),
	methods: {
      ...mapActions({
        save: 'Requerimientos/add',
        clearForm: 'Requerimientos/clearForm',
      }),
  	},
   computed:{
     ...mapState({
     	Datos: state=>state.Requerimientos,
     })
  	}
}
</script>